import React, { useState } from 'react';
import './App.css';

function App() {
  const [targetNumber, setTargetNumber] = useState(null);
  const [userGuess, setUserGuess] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [attempts, setAttempts] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [guessHistory, setGuessHistory] = useState([]);
  const [gameStarted, setGameStarted] = useState(false);

  // 初始化游戏
  const initGame = () => {
    const newTarget = Math.floor(Math.random() * 100) + 1;
    setTargetNumber(newTarget);
    setUserGuess('');
    setMessage('我已经想好了一个1-100之间的数字，开始猜吧！');
    setMessageType('hint');
    setAttempts(0);
    setGameOver(false);
    setGuessHistory([]);
    setGameStarted(true);
    console.log('目标数字:', newTarget); // 开发时可以看到答案，正式发布时可以删除
  };

  // 处理猜测
  const handleGuess = () => {
    const guess = parseInt(userGuess);
    
    if (isNaN(guess) || guess < 1 || guess > 100) {
      setMessage('请输入1-100之间的有效数字！');
      setMessageType('error');
      return;
    }

    const newAttempts = attempts + 1;
    setAttempts(newAttempts);
    
    // 添加到历史记录
    setGuessHistory(prev => [...prev, { guess, attempt: newAttempts }]);
    
    if (guess === targetNumber) {
      setMessage(`恭喜你！你在${newAttempts}次尝试后猜对了！`);
      setMessageType('success');
      setGameOver(true);
    } else if (guess < targetNumber) {
      setMessage(`太小了！再试一次。`);
      setMessageType('hint');
    } else {
      setMessage(`太大了！再试一次。`);
      setMessageType('hint');
    }
    
    setUserGuess('');
  };

  // 处理键盘事件
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (gameOver) {
        initGame();
      } else {
        handleGuess();
      }
    }
  };

  // 渲染历史记录
  // 渲染历史记录 - 倒序排列
  const renderHistory = () => {
    // 使用 slice() 创建副本然后 reverse() 倒序
    return guessHistory.slice().reverse().map((item, index) => (
      <div key={item.attempt} className="history-item">
        <span>第{item.attempt}次尝试: {item.guess}</span>
        <span>
          {item.guess === targetNumber ? '✓' : 
           item.guess < targetNumber ? '↑' : '↓'}
        </span>
      </div>
    ));
  };

  return (
    <div className="App">
      <div className="game-container">
        <h1>猜数字游戏</h1>
        
        <div className="game-description">
          我已经想好了一个1到100之间的数字，看看你能用多少次猜中它！
        </div>
        
        {!gameStarted ? (
          <button className="new-game-btn" onClick={initGame}>
            开始游戏
          </button>
        ) : (
          <>
            <div className="game-area">
              <div className="input-group">
                <input
                  type="number"
                  value={userGuess}
                  onChange={(e) => setUserGuess(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="输入你的猜测 (1-100)"
                  min="1"
                  max="100"
                  disabled={gameOver}
                />
                <button 
                  onClick={handleGuess}
                  disabled={gameOver}
                >
                  猜!
                </button>
              </div>
              
              {message && (
                <div className={`message ${messageType}`}>
                  {message}
                </div>
              )}
              
              <div className="game-info">
                <div className="attempts">尝试次数: {attempts}</div>
                <div className="range">数字范围: 1 - 100</div>
              </div>
              
              {guessHistory.length > 0 && (
                <div className="history">
                  <h3>猜测历史:</h3>
                  {renderHistory()}
                </div>
              )}
            </div>
            
            {gameOver && (
              <button className="new-game-btn" onClick={initGame}>
                再玩一次
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default App;